<template>
  <div
    class="dialpad-container flex-1 flex flex-col justify-start items-center bg-pitch-black text-prime-golden"
    :class="{ 'opacity-30': isDimmed }"
  >
    <!-- Header (Back button and Project info) -->
    <div class="w-full flex justify-between items-center px-4 py-3 bg-pitch-black">
      <div class="text-md text-total-white-700 flex items-center gap-1">
        <button @click="goBack" class="text-xl flex items-center gap-1 mr-2">
          <i class="fas fa-chevron-left text-prime-golden"></i> 
        </button>
        <label for="">Project:</label>
        <span class="font-semibold">{{ selectedProject.address_1 }}</span>
      </div>
      <!--<button @click="goBack" class="text-xs flex items-center gap-1">
        <img src="../assets/images/contacts-icon.svg" /> Search Contacts
      </button>-->
    </div>

    <!-- Dialpad -->
    <div class="flex flex-col justify-center flex-1 items-center">
      <!-- Display input -->
      <div class="text-3xl min-h-10 text-total-white mb-4">{{ formatNumber() }}</div>

      <!-- Conditionally show "add to contacts" when the phone number is valid (11 digits) -->
      <div
        v-if="inputNumber.length >= 11 && !isExistingContact(inputNumber)"
        @click="createContact"
        class="text-prime-golden text-md mb-4 mt-[-8px] cursor-pointer"
      >
        add to contacts
      </div>

      <div v-if="isExistingContact(inputNumber)" class="text-prime-golden text-md mb-4 mt-[-8px] cursor-pointer">
        {{isExistingContact(inputNumber)}}
      </div>

      <!-- Dialpad Buttons -->
      <div class="grid grid-cols-3 gap-y-3 gap-x-6 mb-6 rounded-lg">
        <button
          v-for="key in keys"
          :key="key"
          @click="appendNumber(key)"
          class="dialpad-key"
        >
          {{ key }}
        </button>
      </div>

      <!-- Call and Backspace buttons -->
      <div class="grid grid-cols-[1fr_1fr_1fr] w-full items-center gap-10">
        <div></div>
        <button
          @click="makeCall"
          :disabled="isDimmed"
          class="bg-prime-golden text-pitch-black w-20 h-20 rounded-full"
        >
          <i class="fas fa-phone text-2xl"></i>
        </button>
        <button @click="deleteLastChar" class="text-total-white p-6">
          <i class="fas fa-backspace text-prime-golden-800 text-3xl"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedProject: {
      type: String,
      default: "Cindy's House",
    },
    isExistingContact: {
      type: Function,
      default: () => false,
    },
    isDimmed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      keys: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "+", "0", "#"],
      inputNumber: "+1", // Stores the typed phone number
    };
  },
  methods: {
    appendNumber(key) {
      if (this.inputNumber.length < 14) {
        this.inputNumber += key; // Only allow up to 11 digits
      }
    },
    formatNumber() {
      let formattedNumber = this.inputNumber;
      if (formattedNumber.length === 5 && formattedNumber.startsWith("+1")) {
        formattedNumber = "+1 (" + formattedNumber.slice(2) + ")";
      } else if (this.inputNumber.length >= 6 && this.inputNumber.length <= 8 && formattedNumber.startsWith("+1")) {
        formattedNumber = "+1 (" + formattedNumber.slice(2, 5) + ")-" + formattedNumber.slice(5);
      } else if (this.inputNumber.length >= 9 && this.inputNumber.length <= 12 && formattedNumber.startsWith("+1")) {
        formattedNumber = "+1 (" + formattedNumber.slice(2, 5) + ")-" + formattedNumber.slice(5, 8) + "-" + formattedNumber.slice(8);
      } else if (formattedNumber.length === 3 && !formattedNumber.startsWith("+")) {
        formattedNumber = "+1 (" + formattedNumber + ")";
      } else if (this.inputNumber.length >= 4 && this.inputNumber.length <= 7 && !formattedNumber.startsWith("+")) {
        formattedNumber = "+1 (" + formattedNumber.slice(0, 3) + ")-" + formattedNumber.slice(3);
      } else if (this.inputNumber.length >= 8 && this.inputNumber.length <= 11 && !formattedNumber.startsWith("+")) {
        formattedNumber = "+1 (" + formattedNumber.slice(0, 3) + ")-" + formattedNumber.slice(3, 6) + "-" + formattedNumber.slice(6);
      }
      return formattedNumber;
    },
    deleteLastChar() {
      this.inputNumber = this.inputNumber.slice(0, -1); // Remove the last character
    },
    makeCall() {
      console.log("Calling:", this.inputNumber);
      this.$emit('makeCall', this.inputNumber);
    },
    toggleContactSearch() {
      console.log("Searching contacts...");
    },
    createContact() {
      this.$emit('createContact', this.inputNumber);
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.dialpad-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.dialpad-key {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: rgba(255, 215, 0, 0.1);
  color: #ffd700;
  font-size: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
  border: 2px solid #B295911F;
}
.dialpad-key:hover {
  background-color: rgba(255, 215, 0, 0.3);
}
</style>
